<!--<div *ngIf="!isAttachmentPopup">-->
<!--    <temp-banner></temp-banner>-->
<!--</div>-->

@if (aceOidcWrapperEnabled) {
    <ace-auth-oidc-wrapper
    >
    </ace-auth-oidc-wrapper>
}

@if (appState === AppStates.LoggedOut) {
    <logout-message></logout-message>
}

@if (appState === AppStates.LoggedIn) {
    <nub></nub>
}
